import {Ref, ref} from "vue";
import {EventListener, EventVerteiler} from "@k/global/eventVerteiler";
import {SELOBEVENTNAMES} from "@k/global/GlobalEventnames";
import {CONSTANTS} from "@k/js/meta_data";
import {SelectableObject} from "@k/js/selectableObjects";
import {SelObTypes} from "@k/js/SelObTypes";
export class CommonSelObInteractions {
    public availableZOrders: Ref
    private eventListener: EventListener;

    public constructor() {

        this.availableZOrders = ref( {up: false, down: false});
        this.eventListener = new EventListener();
        this.eventListener.addEventListener(SELOBEVENTNAMES.ZORDER_AVAILABLE, data => {
            this.availableZOrders.value.up = data.up;
            this.availableZOrders.value.down = data.down;
        });
    }

    deleteItem(selOb:SelectableObject) {
        EventVerteiler.broadcast(SELOBEVENTNAMES.DELETEREQUEST, selOb.id);
    }

    zOrderUp = () => this.zOrder("up")
    zOrderDown = () => this.zOrder("down");
    zOrder = (direction) => EventVerteiler.broadcast("executeZOrderOperation", direction);

    sendSizeChange(upOrDown, selOb:SelectableObject) {
        const sizeStep = selOb.type === SelObTypes.TEXT ? CONSTANTS.FONT_SIZESTEP : CONSTANTS.LOGO_SIZESTEP;
        EventVerteiler.broadcast("changedSelObScaleUniformEvent",
            {
                id: selOb.id,
                operator: (upOrDown === "up" ? "+=" : "-=") + sizeStep
            }
        );
    }
}
